import { useMediaQuery } from '@mui/material';
import {
  isTablet,
  useMobileOrientation,
  isMobile as isMobileDeviceDetect,
} from 'react-device-detect';

const IOS_FIXED_POSITION_SUPPORT_MAJOR_VERSION_TRESHOLD = 15;
const IOS_FIXED_POSITION_SUPPORT_MINOR_VERSION_TRESHOLD = 3;

export function useDeviceHelper() {
  const isMobile = useMediaQuery('(max-width:699px)');
  const { isLandscape } = useMobileOrientation();
  const isMobileLandscape = isLandscape && isMobileDeviceDetect && !isTablet;

  const getIosVersion = () => {
    if (/iP(hone|od|ad)/.test(navigator.platform)) {
      // supports iOS 2.0 and later: <http://bit.ly/TJjs1V>
      const v: any = navigator.appVersion.match(/OS (\d+)_(\d+)_?(\d+)?/);
      return [parseInt(v[1], 10), parseInt(v[2], 10), parseInt(v[3] || 0, 10)];
    }
  };

  const isOldIos = (iosVersion: any) => {
    if (!iosVersion) return false;
    const majorVersion = iosVersion[0];
    const minorVersion = iosVersion[1];
    if (majorVersion < IOS_FIXED_POSITION_SUPPORT_MAJOR_VERSION_TRESHOLD) {
      return true;
    }
    return (
      majorVersion === IOS_FIXED_POSITION_SUPPORT_MAJOR_VERSION_TRESHOLD &&
      minorVersion <= IOS_FIXED_POSITION_SUPPORT_MINOR_VERSION_TRESHOLD
    );
  };

  return {
    isMobile,
    isMobileLandscape,
    isOldIos,
    getIosVersion,
  };
}
